import { Link } from "@tanstack/react-router";
import { cn } from "@wags/ui/ui-utils";
import { useScrolledPastTop } from "./scroll/use-scrolled-past-top.ts";

export function Breadcrumb({
    items,
    className,
    hideScrollBorder = false,
}: {
    items: Array<{ label: string; to?: string; onClick?: () => void }>;

    className?: string;
    hideScrollBorder?: boolean;
}) {
    const scrolled = useScrolledPastTop();
    const linkClassName =
        "cursor-pointer rounded-sm transition-colors duration-150 ease-out hover:text-doberman-black motion-reduce:transition-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-labrador-yellow focus-visible:ring-offset-1";

    return (
        <nav aria-label="Breadcrumb" className="relative w-full bg-true-white">
            {!hideScrollBorder && (
                <span
                    aria-hidden="true"
                    className={cn(
                        "pointer-events-none absolute inset-x-0 bottom-0 h-px bg-doberman-black/8 transition-opacity duration-200 ease-out",
                        scrolled ? "opacity-100" : "opacity-0",
                    )}
                />
            )}
            <div
                className={cn(
                    "mx-auto w-full max-w-7xl px-6 pb-5 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
                    className,
                )}
            >
                <ol className="flex flex-nowrap items-center gap-1.5 text-[13px] leading-5 text-doberman-black/50 whitespace-nowrap">
                    {items.map((item, index) => (
                        <li
                            key={item.label}
                            className="flex shrink-0 items-center gap-1.5"
                        >
                            {index > 0 && (
                                <span className="text-doberman-black/30">
                                    /
                                </span>
                            )}
                            {item.onClick ? (
                                <button
                                    type="button"
                                    onClick={item.onClick}
                                    className={linkClassName}
                                >
                                    {item.label}
                                </button>
                            ) : item.to ? (
                                <Link to={item.to} className={linkClassName}>
                                    {item.label}
                                </Link>
                            ) : (
                                <span className="text-doberman-black/80 font-medium">
                                    {item.label}
                                </span>
                            )}
                        </li>
                    ))}
                </ol>
            </div>
        </nav>
    );
}
